import { priceTypes } from './global'

export const jobFilterPrices = [
  {
    label: 'Any Prices',
    value: '_',
  },
  {
    label: '€0 - €20',
    value: '0__20',
  },
  {
    label: '€20 - €50',
    value: '20__50',
  },
  {
    label: '€50 - €100',
    value: '50__100',
  },
  {
    label: '€100 - €500',
    value: '100__500',
  },
  {
    label: '€500 - €1,000',
    value: '500__1000',
  },
  {
    label: '€1,000+',
    value: '1000',
  },
]

export const jobFilterPosted = [
  {
    value: '_',
    label: 'Any Time',
  },
  {
    value: '1hour',
    label: 'Last 1 hour',
  },
  {
    value: '4hours',
    label: 'Last 4 hours',
  },
  {
    value: '8hours',
    label: 'Last 8 hours',
  },
  {
    value: '24hours',
    label: 'Last 24 hours',
  },
  {
    value: 'today',
    label: 'Today',
  },
  {
    value: 'yesterday',
    label: 'Yesterday',
  },
  {
    value: 'this_week',
    label: 'This Week',
  },
  {
    value: 'this_month',
    label: 'This Month',
  },
]

export const jobFilterPriceTypes = [
  {
    value: '_',
    label: 'Any Type',
  },
  ...priceTypes,
]

export const jobSortOptions = [
  {
    value: 'name_a_z',
    label: 'Name A-Z',
  },
  {
    value: 'name_z_a',
    label: 'Name Z-A',
  },
  {
    value: 'price_low_high',
    label: 'Price low-high',
  },
  {
    value: 'price_high_low',
    label: 'Price high-low',
  },
  {
    value: 'highest_rating',
    label: 'Highest Rating',
  },
  {
    value: 'lowest_rating',
    label: 'Lowest Rating',
  },
  {
    value: 'more_classes_completed',
    label: 'More Classes Completed',
  },
  {
    value: 'less_classes_completed',
    label: 'Less Classes Completed',
  },
  {
    value: 'most_students',
    label: 'Most Students',
  },
  {
    value: 'least_students',
    label: 'Least Students',
  },
]
